/* eslint-disable no-unused-vars */
import React from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";
import { withTheme } from "emotion-theming";
import CompfestLogo from "components/CompfestLogo";

const Section = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 16px 64px;
  flex-direction: column;
  color: ${props => props.theme.colors.body};

  @media (max-width: 840px) {
    padding: 16px 28px;
  }

  @media (max-width: 640px) {
    padding: 16px 36px;
  }
`;

const TopSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const Logo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 3;
  flex-basis: 0;

  @media (max-width: 1200px) {
    flex-grow: 1;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-basis: auto;
  }
`;

const LogoOnly = styled.div`
  margin-bottom: 21px;

  @media (max-width: 640px) {
    margin-bottom: 12px;
    svg {
      height: 36px;
    }
  }
`;

const SocialMedia = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 32px;

  svg {
    width: 24px;
  }

  a {
    margin-right: 18px;
  }

  @media (max-width: 640px) {
    margin-bottom: 44px;
    a {
      margin: 0 7px;
    }
    svg {
      width: 22px;
    }
  }
`;

const News = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  flex-direction: column;

  b {
    margin: 0 0 24px 0;
    font-size: 16px;
  }

  @media (max-width: 640px) {
    text-align: center;
    margin-bottom: 28px;
    b {
      font-size: 20px;
      margin-bottom: 16px;
    }
    flex-basis: auto;
  }
`;

const FormNews = styled.form`
  display: flex;
  justify-content: space-between;
`;

const Email = styled.div`
  width: 100%;
  padding-right: 16px;
`;

const InputEmail = styled.input`
  width: 100%;
  background: none;
  border: none;
  padding-bottom: 7px;
  font-family: ${props => props.theme.fonts.body};
  color: ${props => props.theme.colors.body};

  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: ${props => props.theme.colors.body};
    opacity: 0.5;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: ${props => props.theme.colors.body};
    opacity: 0.5;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: ${props => props.theme.colors.body};
    opacity: 0.5;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${props => props.theme.colors.body};
    opacity: 0.5;
  }
  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${props => props.theme.colors.body};
    opacity: 0.5;
  }
  ::placeholder {
    /* Most modern browsers support this now. */
    color: ${props => props.theme.colors.body};
    opacity: 0.5;
  }

  :hover {
    ::-webkit-input-placeholder {
      opacity: 1;
    }
    :-moz-placeholder {
      opacity: 1;
    }
    ::-moz-placeholder {
      opacity: 1;
    }
    :-ms-input-placeholder {
      opacity: 1;
    }
    ::-ms-input-placeholder {
      opacity: 1;
    }
    ::placeholder {
      opacity: 1;
    }

    + hr {
      opacity: 0.5;
    }
  }
`;

const InputLine = styled.hr`
  margin: 0;
  color: ${props => props.theme.colors.body};
  opacity: 0.25;
`;

const InputSubmit = styled.input`
  font-family: ${props => props.theme.fonts.body};
  font-weight: 500;
  color: #000000;
  border: none;
  border-radius: 13px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  background: #fff;
  padding: 6px 10px 4px 10px;
`;

const BottomSection = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding-right: 5px;
  flex-grow: 1;
  flex-basis: 0;

  a {
    color: ${props => props.theme.colors.body};
    transition: 0.2s color;
    padding: 2px;
  }
  a:hover {
    color: #fc8dca;
  }

  div {
    transition: 0.2s transform;
    padding: 4px 0;
  }
  @media (max-width: 640px) {
    flex-direction: column;
    margin: 15px 0;
    flex-basis: auto;
  }
`;

const FooterLink = styled.div`
  & :hover {
    transform: translateX(8px);
  }
`;

const Copyright = styled.p`
  width: 100%;
  text-align: center;
  margin-top: 48px;
`;

const Facebook = withTheme(props => {
  return (
    <a aria-label="Facebook" href={props.url}>
      <svg
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.0288 0H3.58041C2.63083 0 1.72014 0.377221 1.04868 1.04868C0.377221 1.72014 0 2.63083 0 3.58041L0 25.0288C0.0045078 25.9754 0.383718 26.8817 1.05469 27.5495C1.72566 28.2173 2.63378 28.5922 3.58041 28.5922H14.3046V18.7546H10.7242V14.3046H14.3046V10.7242C14.3024 10.0205 14.4393 9.32335 14.7075 8.67281C14.9758 8.02227 15.37 7.4312 15.8676 6.93362C16.3652 6.43605 16.9563 6.0418 17.6068 5.77355C18.2573 5.50531 18.9545 5.36837 19.6582 5.37062H23.2386V9.83761H21.4484C20.4595 9.83761 19.6582 9.73532 19.6582 10.7242V14.3046H24.1252L22.335 18.7546H19.6582V28.5751H25.0288C25.9725 28.5706 26.8762 28.1938 27.5435 27.5265C28.2108 26.8592 28.5877 25.9554 28.5922 25.0118V3.58041C28.5922 2.63378 28.2173 1.72566 27.5495 1.05469C26.8817 0.383718 25.9754 0.0045078 25.0288 0V0Z"
          fill={props.theme.colors.body}
        />
      </svg>
    </a>
  );
});

const Twitter = withTheme(props => {
  return (
    <a aria-label="Twitter" href={props.url}>
      <svg
        height="28"
        viewBox="0 0 35 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.4061 3.28262C33.1103 3.85206 31.7369 4.22556 30.3312 4.39084C31.8125 3.52553 32.9187 2.13978 33.4342 0.503535C32.0503 1.31612 30.5406 1.89233 28.9673 2.20849C27.9011 1.08348 26.495 0.339678 24.965 0.0913847C23.4351 -0.156908 21.8659 0.104044 20.4987 0.834144C19.1314 1.56424 18.0418 2.7231 17.3971 4.13263C16.7524 5.54217 16.5884 7.12439 16.9302 8.63619C14.1237 8.49545 11.3783 7.76535 8.87257 6.49341C6.36686 5.22146 4.15705 3.43617 2.38694 1.25372C1.76587 2.33894 1.4369 3.56671 1.43217 4.81708C1.43132 5.9775 1.71726 7.12013 2.26458 8.14337C2.81189 9.1666 3.6036 10.0387 4.56929 10.6821C3.45132 10.6581 2.35642 10.3595 1.38102 9.81261V9.89786C1.37942 11.5254 1.94032 13.1035 2.96875 14.365C3.99717 15.6264 5.42993 16.4937 7.02443 16.82C6.39999 16.9736 5.75769 17.0424 5.11488 17.0246C4.68955 17.0639 4.26149 17.0639 3.83616 17.0246C4.29377 18.4245 5.17388 19.6483 6.35544 20.5276C7.53699 21.4069 8.96196 21.8985 10.4343 21.9349C7.92882 23.8487 4.8577 24.8744 1.70496 24.8504C1.13543 24.8571 0.566018 24.8287 0 24.7651C3.22792 26.8412 6.98859 27.9369 10.8265 27.9193C13.4668 27.9374 16.0845 27.4307 18.5273 26.4287C20.9702 25.4266 23.1896 23.9492 25.0567 22.0821C26.9237 20.2151 28.4012 17.9956 29.4033 15.5528C30.4053 13.1099 30.912 10.4923 30.8939 7.85191C30.8939 7.54502 30.8939 7.23812 30.8939 6.94828C32.275 5.94697 33.4647 4.7053 34.4061 3.28262Z"
          fill={props.theme.colors.body}
        />
      </svg>
    </a>
  );
});

const Youtube = withTheme(props => {
  return (
    <a aria-label="Youtube" href={props.url}>
      <svg
        height="26"
        viewBox="0 0 38 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.8041 2.47219C34.73 0.664934 33.6218 0.340992 31.3883 0.221645C29.1548 0.102298 23.5284 0 18.7545 0C13.9807 0 8.16675 0 5.93326 0.204595C3.69976 0.40919 2.60859 0.664934 1.58561 2.47219C0.562636 4.27945 0 7.36542 0 12.8213C0 18.2601 0.528537 21.3461 1.58561 23.1533C2.64269 24.9606 3.69976 25.2845 5.93326 25.438C8.16675 25.5914 13.7931 25.6426 18.6693 25.6426C23.5455 25.6426 29.1548 25.6426 31.3883 25.438C33.6218 25.2334 34.7982 24.9606 35.7359 23.1533C36.6737 21.3461 37.3216 18.2601 37.3216 12.8213C37.3216 7.36542 36.793 4.27945 35.8041 2.47219ZM13.9977 19.8287V5.83096L25.6596 12.8383L13.9977 19.8287Z"
          fill={props.theme.colors.body}
        />
      </svg>
    </a>
  );
});

const Instagram = withTheme(props => {
  return (
    <a aria-label="Instagram" href={props.url}>
      <svg
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.7733 0.118667H9.44395C8.20314 0.116431 6.9741 0.363419 5.82731 0.845465C4.68053 1.32751 3.63857 2.03513 2.76118 2.92775C1.88379 3.82036 1.18824 4.88041 0.714415 6.04709C0.240591 7.21378 -0.00218329 8.46415 1.47934e-05 9.72649V21.2525C1.47934e-05 23.8006 0.994998 26.2444 2.76608 28.0463C4.53716 29.8481 6.93926 30.8603 9.44395 30.8603H20.7733C23.2767 30.8558 25.6762 29.8421 27.4463 28.0413C29.2165 26.2405 30.2129 23.7993 30.2173 21.2525V9.72649C30.2173 7.17834 29.2223 4.73455 27.4512 2.93273C25.6801 1.13092 23.278 0.118667 20.7733 0.118667ZM27.4475 21.2525C27.4475 23.0533 26.7443 24.7804 25.4927 26.0537C24.241 27.3271 22.5434 28.0425 20.7733 28.0425H9.44395C7.67385 28.0425 5.97626 27.3271 4.72461 26.0537C3.47296 24.7804 2.76979 23.0533 2.76979 21.2525V9.72649C2.76979 7.92568 3.47296 6.19862 4.72461 4.92525C5.97626 3.65188 7.67385 2.93651 9.44395 2.93651H20.7733C22.5434 2.93651 24.241 3.65188 25.4927 4.92525C26.7443 6.19862 27.4475 7.92568 27.4475 9.72649V21.2525Z"
          fill={props.theme.colors.body}
        />
        <path
          d="M15.1002 7.80764C13.6046 7.80764 12.1426 8.25906 10.8992 9.10477C9.65588 9.95047 8.6871 11.1524 8.11551 12.5585C7.54392 13.9646 7.39521 15.5116 7.68821 17.0037C7.98121 18.4959 8.70275 19.866 9.76149 20.9407C10.8202 22.0155 12.1686 22.7465 13.6359 23.0413C15.1032 23.3361 16.6235 23.1814 18.0043 22.5968C19.3851 22.0121 20.5645 21.0239 21.393 19.7571C22.2215 18.4903 22.662 17.0019 22.6587 15.4803C22.6587 14.4713 22.4631 13.4722 22.083 12.5402C21.703 11.6082 21.146 10.7616 20.4439 10.0489C19.7418 9.33621 18.9084 8.7714 17.9915 8.38681C17.0745 8.00222 16.092 7.8054 15.1002 7.80764ZM15.1002 20.2843C14.1663 20.2843 13.2534 20.0025 12.4768 19.4747C11.7003 18.9468 11.0951 18.1965 10.7377 17.3187C10.3803 16.4409 10.2868 15.475 10.469 14.5431C10.6512 13.6113 11.1009 12.7553 11.7613 12.0834C12.4217 11.4116 13.263 10.9541 14.179 10.7687C15.095 10.5834 16.0444 10.6785 16.9072 11.0421C17.7701 11.4057 18.5075 12.0214 19.0264 12.8114C19.5453 13.6014 19.8222 14.5302 19.8222 15.4803C19.8222 16.1112 19.7001 16.7359 19.4628 17.3187C19.2255 17.9016 18.8776 18.4311 18.4392 18.8772C18.0007 19.3233 17.4801 19.6772 16.9072 19.9186C16.3343 20.16 15.7203 20.2843 15.1002 20.2843Z"
          fill={props.theme.colors.body}
        />
        <path
          d="M23.2265 8.24894C23.7794 8.24894 24.2276 7.79294 24.2276 7.23043C24.2276 6.66792 23.7794 6.21191 23.2265 6.21191C22.6736 6.21191 22.2253 6.66792 22.2253 7.23043C22.2253 7.79294 22.6736 8.24894 23.2265 8.24894Z"
          fill={props.theme.colors.body}
        />
      </svg>
    </a>
  );
});

const Line = withTheme(props => {
  return (
    <a aria-label="Line OA" href={props.url}>
      <svg
        height="34"
        viewBox="0 0 35 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.388 13.088V12.7485V12.5109C33.9305 10.0066 32.7717 7.69005 31.051 5.83972C29.1976 3.84805 26.912 2.32501 24.3768 1.39227C22.1235 0.507694 19.7339 0.0364225 17.3189 0.000323333C14.1355 -0.0181708 10.9961 0.756978 8.17525 2.258C5.70524 3.43363 3.63191 5.3258 2.21583 7.6967C0.799744 10.0676 0.104095 12.8114 0.216309 15.5834C0.467394 18.324 1.51924 20.9253 3.23637 23.0524C4.95259 25.1558 7.15373 26.7945 9.64357 27.8223C11.1852 28.4257 12.7846 28.8638 14.4156 29.1294H14.5991C15.0663 29.1294 15.1831 29.3331 15.2165 29.384C15.2499 29.5062 15.2499 29.6353 15.2165 29.7575C15.2165 29.8593 15.2165 29.9442 15.2165 30.0291C14.9755 30.7783 14.9014 31.5727 14.9996 32.3547C15.045 32.7718 15.2406 33.157 15.5487 33.436C15.8568 33.715 16.2556 33.868 16.6681 33.8654C17.635 33.7447 18.5577 33.3832 19.3545 32.813H19.4379C21.1064 31.8284 22.6749 30.6911 23.8595 29.8254C26.7186 27.9198 29.3164 25.6365 31.5849 23.0354C33.7731 20.2259 34.7807 16.7683 34.388 13.088ZM10.8783 18.4012H7.92497C7.81917 18.4035 7.714 18.384 7.61581 18.3439C7.51761 18.3038 7.42841 18.2439 7.35358 18.1677C7.27875 18.0916 7.21984 18.0009 7.1804 17.901C7.14095 17.801 7.12179 17.6941 7.12407 17.5864V11.2717C7.12179 11.1641 7.14095 11.0571 7.1804 10.9572C7.21984 10.8573 7.27875 10.7665 7.35358 10.6904C7.42841 10.6143 7.51761 10.5544 7.61581 10.5142C7.714 10.4741 7.81917 10.4546 7.92497 10.4569C8.03154 10.4547 8.13748 10.4741 8.23659 10.514C8.33569 10.5539 8.42596 10.6136 8.50211 10.6895C8.57825 10.7654 8.63875 10.856 8.68003 10.9559C8.72132 11.0559 8.74258 11.1633 8.74255 11.2717V16.7546H10.8783C11.0951 16.7546 11.3031 16.8423 11.4564 16.9983C11.6097 17.1543 11.6959 17.3658 11.6959 17.5864C11.6959 17.6949 11.6746 17.8022 11.6334 17.9022C11.5921 18.0022 11.5316 18.0928 11.4554 18.1687C11.3793 18.2445 11.289 18.3042 11.1899 18.3441C11.0908 18.3841 10.9849 18.4035 10.8783 18.4012ZM13.9651 17.5694C13.9651 17.7945 13.8772 18.0104 13.7207 18.1696C13.5643 18.3288 13.3521 18.4182 13.1308 18.4182C12.9096 18.4182 12.6974 18.3288 12.5409 18.1696C12.3844 18.0104 12.2965 17.7945 12.2965 17.5694V11.2547C12.2965 11.0296 12.3844 10.8138 12.5409 10.6546C12.6974 10.4954 12.9096 10.406 13.1308 10.406C13.3521 10.406 13.5643 10.4954 13.7207 10.6546C13.8772 10.8138 13.9651 11.0296 13.9651 11.2547V17.5694ZM21.2733 17.5694C21.271 17.7436 21.2151 17.9127 21.1133 18.0528C21.0115 18.1929 20.869 18.297 20.706 18.3503H20.4557C20.3283 18.3518 20.2025 18.3216 20.0891 18.2624C19.9757 18.2033 19.8782 18.1169 19.805 18.0108L16.9017 13.9707V17.5694C16.8974 17.7871 16.8093 17.9943 16.6564 18.1467C16.5036 18.299 16.2981 18.3843 16.0841 18.3842C15.9748 18.3912 15.8653 18.3753 15.7623 18.3375C15.6592 18.2997 15.5649 18.2407 15.4852 18.1644C15.4054 18.088 15.3419 17.9958 15.2986 17.8935C15.2552 17.7912 15.233 17.6809 15.2332 17.5694V11.4415C15.2333 11.267 15.2861 11.0969 15.3847 10.9541C15.4832 10.8114 15.6226 10.703 15.7838 10.6436C15.9466 10.5928 16.1209 10.5949 16.2824 10.6497C16.4439 10.7044 16.5846 10.8092 16.6848 10.9492L19.6048 15.0232V11.2547C19.6048 11.0296 19.6927 10.8138 19.8491 10.6546C20.0056 10.4954 20.2178 10.406 20.439 10.406C20.6603 10.406 20.8725 10.4954 21.0289 10.6546C21.1854 10.8138 21.2733 11.0296 21.2733 11.2547V17.5694ZM27.1632 18.2484H23.1588C23.053 18.2508 22.9478 18.2313 22.8496 18.1911C22.7514 18.151 22.6622 18.0911 22.5874 18.015C22.5125 17.9388 22.4536 17.8481 22.4142 17.7482C22.3747 17.6483 22.3556 17.5413 22.3579 17.4336V11.1189C22.3579 10.9028 22.4422 10.6956 22.5924 10.5428C22.7426 10.39 22.9463 10.3041 23.1588 10.3041H27.0298C27.251 10.3041 27.4632 10.3936 27.6197 10.5527C27.7761 10.7119 27.864 10.9278 27.864 11.1529C27.864 11.378 27.7761 11.5939 27.6197 11.7531C27.4632 11.9122 27.251 12.0016 27.0298 12.0016H23.9597V13.5124H26.4625C26.6749 13.5124 26.8786 13.5983 27.0288 13.7511C27.179 13.9039 27.2634 14.1111 27.2634 14.3272C27.2634 14.5449 27.1796 14.7539 27.0298 14.9095C26.8801 15.065 26.6764 15.1546 26.4625 15.159H23.9597V16.6698H27.1632C27.3845 16.6698 27.5967 16.7592 27.7532 16.9184C27.9096 17.0775 27.9975 17.2934 27.9975 17.5185C27.9975 17.7436 27.9096 17.9595 27.7532 18.1187C27.5967 18.2778 27.3845 18.3673 27.1632 18.3673V18.2484Z"
          fill={props.theme.colors.body}
        />
      </svg>
    </a>
  );
});

const LinkedIn = withTheme(props => {
  return (
    <a aria-label="LinkedIn" href={props.url}>
      <svg
        height="29"
        viewBox="0 0 30 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.4668 18.0007V28.801H23.2055V18.7241C23.2055 16.1927 22.2999 14.4651 20.0335 14.4651C18.3034 14.4651 17.2738 15.6293 16.8209 16.7556C16.6557 17.1582 16.6132 17.7186 16.6132 18.2822V28.801H10.3498C10.3498 28.801 10.4341 11.734 10.3498 9.96574H16.6125V12.6356C16.5998 12.6555 16.5833 12.6771 16.5714 12.6964H16.6125V12.6356C17.4446 11.354 18.9306 9.52325 22.2567 9.52325C26.3776 9.52318 29.4668 12.2153 29.4668 18.0007ZM3.79799 0.88623C1.65529 0.88623 0.253784 2.29167 0.253784 4.13988C0.253784 5.9478 1.61474 7.3959 3.71485 7.3959H3.75669C5.94089 7.3959 7.29926 5.94808 7.29926 4.13988C7.2581 2.29167 5.94089 0.88623 3.79799 0.88623ZM0.625775 28.801H6.88679V9.96574H0.625775V28.801Z"
          fill={props.theme.colors.body}
        />
      </svg>
    </a>
  );
});

export function FooterNew() {
  return (
    <Section>
      <TopSection>
        <Logo>
          <LogoOnly>
            <Link aria-label="COMPFEST" to="/">
              <CompfestLogo height="28" />
            </Link>
          </LogoOnly>
          <SocialMedia>
            <Facebook url="https://www.facebook.com/COMPFEST" />
            <Twitter url="https://twitter.com/COMPFEST" />
            <Youtube url="https://www.youtube.com/channel/UC03QmhwvQEWVI608A-RCEpw" />
            <Instagram url="https://www.instagram.com/compfest" />
            <Line url="https://line.me/R/ti/p/%40compfest" />
            <LinkedIn url="https://www.linkedin.com/company/compfest" />
          </SocialMedia>
        </Logo>
      </TopSection>

      <BottomSection>
        <BottomPart>
          <FooterLink>
            <Link to="/about">About COMPFEST</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/blog">Blog</Link>
          </FooterLink>
        </BottomPart>

        <BottomPart>
          <div>
            <strong>COMPETITION</strong>
          </div>
          <FooterLink>
            <Link to="/competition/bizz-it">Business-IT Case</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/competition/ctf">Capture The Flag</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/competition/igi">Indie Game Ignite</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/competition/cpc">Competitive Programming Contest</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/competition/iac">Innovative App Competition</Link>
          </FooterLink>
        </BottomPart>

        <BottomPart>
          <div>
            <strong>ACADEMY</strong>
          </div>
          <FooterLink>
            <Link to="/academy/startup">Startup Academy</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/academy/dsa">Data Science Academy</Link>
          </FooterLink>
          <FooterLink>
            <Link to="/academy/sea">Software Engineering Academy</Link>
          </FooterLink>
        </BottomPart>
      </BottomSection>
      <Copyright>© 2019 COMPFEST</Copyright>
    </Section>
  );
}

export default React.memo(FooterNew);
